import React from 'react';

import Guidance from '../common/Guidance';
import { matchKey } from '../../utils/combinedLists';

export const COMBINED_LIST_GUIDE = 'finding-and-lists/use-a-combined-list';

/**
 * THE SUGGESTION (KPR-1022; plan §4 "suggested, not configured"): on a card's
 * List, when two or more of the person's collections hold that card, keepr
 * offers the combined list once, through the one `Guidance` nudge. Dismissed,
 * it stays dismissed for that match (per viewer); saved, the API stops
 * offering it.
 *
 * The counts are keepr's (`collections` of the suggestion); it never names
 * which collections — the list does, once opened.
 */
export default function CombinedListSuggestion({ suggestion, plural = 'items', onOpen, className = '' }) {
	if (!suggestion || !onOpen) return null;
	const count = Number(suggestion.collections) || Number(suggestion.sources) || 0;
	if (count < 2) return null;
	return (
		<Guidance
			className={className}
			tone="suggest"
			title={`${plural} are in ${count} of your collections`}
			why="A combined list shows them together, with one search and one filter. Each one says which collection it’s in."
			action={{ label: `See all ${count}`, onClick: onOpen }}
			links={[COMBINED_LIST_GUIDE]}
			dismissKey={`combined-list:${matchKey(suggestion.match)}`}
		/>
	);
}
